<template>
    <div>
      <e-invoice-list></e-invoice-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>